// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsInteractionBar-cls1_q68","cls2":"NewsInteractionBar-cls2_gT5 NewsInteractionBar-cls1_q68"};